module.exports = __webpack_public_path__ + "img/中文联盟LOGO.51f67b93.png";